var SwatchGroup = Backbone.Model.extend({
    defaults: {
        'label': '',
        'type' : '',
        'swatches': null
    },
    initialize: function(){
        let collection = new Backbone.Collection();
        this.set( 'swatches', collection );
    }
});
export {SwatchGroup};